import { uploadSingleFile } from "../files";
import { authClient, API } from "../index";

// Get all cursos
export const getCursos = () => {
  return authClient().get(`${API}/curso?getDisabled=true`);
};

// Get curso by id
export const getCursoById = (id, { join = false } = {}) => {
  const query = join ? "?join=true" : "";
  return authClient().get(`${API}/curso/${id}${query}`);
};

// Delete curso
export const deleteCurso = (id) => {
  return authClient().delete(`${API}/curso/${id}`);
};

// Create curso
export const postCurso = async (curso, image, imageGrid) => {
  // Solo subir archivos si son instancias de File
  if (image && image instanceof File) {
    const response = await uploadSingleFile(image, "cursos");
    curso.imageURL = response?.data?.fileURL;
  }
  if (imageGrid && imageGrid instanceof File) {
    const response = await uploadSingleFile(imageGrid, "cursos");
    curso.imageGridURL = response?.data?.fileURL;
  }
  return authClient().post(`${API}/curso`, curso);
};

// duplicar curso
export const duplicarCurso = async (id, curso) => {
  return authClient().post(`${API}/curso/${id}`, curso);
};

// Update curso
export const updateCurso = async (id, curso, image, imageGrid) => {
  // Solo subir archivos si son instancias de File
  if (image && image instanceof File) {
    const response = await uploadSingleFile(image, "cursos");
    curso.imageURL = response?.data?.fileURL;
  }
  if (imageGrid && imageGrid instanceof File) {
    const response = await uploadSingleFile(imageGrid, "cursos");
    curso.imageGridURL = response?.data?.fileURL;
  }
  for (let i = 0; i < curso?.documentos?.length; i++) {
    const file = curso.documentos[i];
    if (typeof file.url !== "string") {
      let fileURL = await uploadSingleFile(file.url, "cursos");
      curso.documentos[i] = {
        ...file,
        url: fileURL?.data?.fileURL?.replace(/\\/g, "/"),
      };
    }
  }
  return authClient().put(`${API}/curso/${id}`, curso);
};

export const asegurarEnlaceInscripcion = (id, { registroWeb } = {}) => {
  return authClient().put(`${API}/curso/${id}/asegurar-enlace-inscripcion`, {
    registroWeb,
  });
};

export const regenerateInscripcionEnlace = (id, { registroWeb } = {}) => {
  return authClient().put(`${API}/curso/${id}/regenerar-enlace-inscripcion`, {
    registroWeb,
  });
};

// Change status curso
export const changeStatusCurso = async (id, active) => {
  return authClient().put(`${API}/curso/change-status/${id}`, { active });
};

export const changeVisibleCurso = async (id, visible) => {
  return authClient().put(`${API}/curso/change-visible/${id}`, { visible });
};

export const changeStatusRegistroCurso = async (id, registroWeb) => {
  return authClient().put(`${API}/curso/change-registro/${id}`, {
    registroWeb,
  });
};

// Change order curso
export const changeOrderCurso = async (id, up) => {
  return authClient().put(`${API}/curso/change-order/${id}`, { up });
};

// Change order curso
export const recordatorioInteresado = async (id, insId) => {
  return authClient().put(`${API}/curso/${id}/recor-insc/${insId}`);
};

export const aprovarInteresado = async (id, insId, aprovado) => {
  return authClient().put(`${API}/curso/${id}/apro-insc/${insId}`, {
    aprovado,
  });
};

// Valoraciones del curso (solo admin)
export const getCursoRatingsByCurso = (cursoId) => {
  return authClient().get(`${API}/curso-rating/curso/${cursoId}/admin`);
};

export const setCursoRatingValidated = (ratingId, validated) => {
  return authClient().put(`${API}/curso-rating/${ratingId}/validate`, {
    validated,
  });
};

export const deleteCursoRating = (ratingId) => {
  return authClient().delete(`${API}/curso-rating/${ratingId}`);
};
